import React, { useEffect } from "react";
import { SetPageTitle } from "../../../helpers/appsession";
import "../../../styles/masters.css";

/** Page shell for a Masters screen: sets the top-bar title once and wraps the content. */
export default function MasterPage({ title, children }) {
  useEffect(() => {
    SetPageTitle(title);
  }, [title]);

  return <div className="mst-page">{children}</div>;
}
